export default function Loading({ extra }) {
  return <div className={`animate-pulse bg-gray-300 ${extra}`}></div>;
}
